import React, { type FC, type ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';

import { useGetOrderPositions } from 'api';

import styles from 'theme/components/wise/WiseCartImportModal/WiseCartImportModal.module.scss';

export type OrderPositionsTooltipProps = {
  orderId: number;
  children: ReactElement;
};

const OrderPositionsTooltip: FC<OrderPositionsTooltipProps> = ({ orderId, children }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const { data, isFetching } = useGetOrderPositions(
    orderId,
    { limit: 50, page: 1 },
    { enabled: open, staleTime: 60_000 }
  );

  const positions = data?.items ?? [];

  return (
    <Tooltip
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      arrow
      placement="left"
      title={
        <div className={styles.tooltipContent}>
          {isFetching && <div>{t('Ladowanie...')}</div>}
          {!isFetching && positions.length === 0 && (
            <div>{t('Brak pozycji do wyswietlenia')}</div>
          )}
          {!isFetching && positions.length > 0 && (
            <ul>
              {positions.slice(0, 10).map((position) => (
                <li key={position.id}>
                  {position.name} - {position.quantity}
                </li>
              ))}
              {positions.length > 10 && (
                <li>... {t('i wiecej')}</li>
              )}
            </ul>
          )}
        </div>
      }>
      {children}
    </Tooltip>
  );
};

export default OrderPositionsTooltip;
